import api from './api';
import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiBaseUrl';

const publicApi = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
});

const fieldsService = {
  /** List current user's fields only (for My Fields page). */
  getAll: () => api.get('/api/fields'),
  /** List all fields for map (discovery, browse, buy). Prefer including occupied_total_m2 (+ available) per row on the backend to avoid per-field /occupancy calls. */
  getAllForMap: () => api.get('/api/fields/all'),
  /** List fields available for farmer to rent (other owners' fields). Farmer-only. */
  getAvailableToRent: () => api.get('/api/fields/available-to-rent'),
  /** Get public fields - no authentication required */
  getPublicFields: () => publicApi.get('/api/fields/public'),
  getById: (id) => api.get(`/api/fields/${id}`),
  /** Farmer: declared harvest history for a field (after marking orders completed). */
  getHarvestDeclarations: (fieldId) => api.get(`/api/fields/${fieldId}/harvest-declarations`),
  getHarvestEvents: (fieldId) => api.get(`/api/fields/${fieldId}/harvest-events`),
  completeHarvest: (fieldId, body) => api.post(`/api/fields/${fieldId}/complete-harvest`, body),
  markShipped: (fieldId) => api.post(`/api/fields/${fieldId}/mark-shipped`),
  listAgain: (fieldId, body) => api.post(`/api/fields/${fieldId}/list-again`, body),
  create: (data) => api.post('/api/fields', data),
  update: (id, data) => api.put(`/api/fields/${id}`, data),
  remove: (id) => api.delete(`/api/fields/${id}`),
};

export default fieldsService;
